module.exports = __webpack_public_path__ + "static/media/icons8-github.642525f6.svg";